export const extractApiErrorMessage = (data) => {
  if (!data) return null;

  if (typeof data === "string") return data;

  const direct =
    data.Detail || data.detail || data.Message || data.message || data.title || data.Title;
  if (direct && typeof direct === "string" && direct.trim()) return direct;

  const errors = data.Errors || data.errors;
  if (!errors) return null;

  if (Array.isArray(errors)) {
    const first = errors[0];
    if (typeof first === "string") return first;
    return first?.ErrorMessage || first?.errorMessage || first?.message || null;
  }

  if (typeof errors === "object") {
    const messages = Object.entries(errors).flatMap(([key, value]) => {
      if (Array.isArray(value)) return value.map((item) => `${key}: ${item}`);
      if (typeof value === "string") return [`${key}: ${value}`];
      return [];
    });
    if (messages.length > 0) return messages.join("\n");
  }

  return null;
};
